/**
 * atomberg-cart-discount-cleanup.js
 *
 * Shopify stores discount codes on the cart itself and keeps them there even
 * when they're not applicable — so a code rejected with "not valid" silently
 * sticks to the cart and self-applies the moment an eligible product lands,
 * and a code whose item was removed re-applies when the item is re-added.
 * Horizon's cart-discount component shows the error but never removes the
 * inapplicable code from the cart.
 *
 * This sweeper removes non-applicable codes whenever the cart changes:
 *   - on page load (ghost codes from earlier pages/sessions)
 *   - on Horizon's cart:update event (add/change/remove)
 *   - shortly after a discount-form submit (a REJECTED apply fires no cart
 *     event, so this is the only hook for the "error but sticks" case)
 * Applicable codes are never touched, and inapplicable codes render nothing
 * in the cart UI, so no re-render is needed after a sweep.
 */
(function () {
  if (/** @type {any} */ (window)._atombergCartDiscountCleanupInit) return;
  /** @type {any} */ (window)._atombergCartDiscountCleanupInit = true;

  var sweeping = false;

  function sweep() {
    if (sweeping) return;
    sweeping = true;
    var shared = /** @type {any} */ (window).AtombergCartState;
    var req = shared
      ? shared.getCart({ fresh: true })
      : fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
          return r.json();
        });
    req
      .then(function (/** @type {any} */ cart) {
        /** @type {Array<{code: string, applicable: boolean}>} */
        var codes = (cart && cart.discount_codes) || [];
        var keep = codes
          .filter(function (c) {
            return c.applicable;
          })
          .map(function (c) {
            return c.code;
          });
        if (keep.length === codes.length) return null;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: keep.join(',') }),
        });
      })
      .catch(function () {})
      .then(function () {
        sweeping = false;
      });
  }

  document.addEventListener('cart:update', function () {
    sweep();
  });

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.closest('cart-discount-component')) return;
      // Wait for Horizon's apply request to settle before checking the
      // cart — sweeping mid-flight would race its cart/update call.
      setTimeout(sweep, 1200);
    },
    true
  );

  sweep();
})();
